export enum AbsenceDecision {
  Approve = 'approve',
  Reject = 'reject',
  RequestChanges = 'request-changes',
}
